import { type AlertSeverity, type HeadingLevel } from "../common";

export const DEFAULT_SEVERITY = "info" satisfies AlertSeverity;

export const DEFAULT_HEADING_LEVEL = 2 satisfies HeadingLevel;
